const dataWiz: Record<number, string> = {
  1: '#82D2FB',
  2: '#5ABFF8',
  3: '#3F92CB',
  4: '#99BAD0',
  5: '#3E7091',
  6: '#315C7E',
  7: '#DE5558',
  8: '#82BDB1',
  9: '#5DAC9F',
  10: '#3F8678',
  11: '#31675C',
  12: '#9DA7FF',
  13: '#6D81FF',
  14: '#4F6AFF',
  15: '#4156D1',
  16: '#EBB275',
  17: '#D97A14',
  18: '#B66612',
  19: '#DBD048',
  20: '#B4AA23',
  21: '#E496BD',
  22: '#902B49',
  23: '#7A7A7A',
  24: '#CCB3F5',
  25: '#A67BEC',
  26: '#A5D671',
  27: '#7DBB22',
  28: '#507A13',
};

const ALL_COLORS = Object.values(dataWiz);

const GREEN_COLORS = [dataWiz[29], dataWiz[28], dataWiz[26], dataWiz[11], dataWiz[10]];

const ALERT_COLORS = [dataWiz[15], dataWiz[19], dataWiz[27], dataWiz[17], dataWiz[7]];

const getColorRange = (range: number): string[] => (range <= 5 ? GREEN_COLORS : Object.values(dataWiz));

export { ALERT_COLORS, ALL_COLORS as default, ALL_COLORS, GREEN_COLORS, getColorRange };
